module.exports = __webpack_public_path__ + "img/Stock.c11459a1.png";